// import initInlineHorizontal from './utils/inline-horizontal.js';
import initLineFade from './utils/line-fade.js';
import initRadarChart from './utils/radar-chart.js';
import initTab from './utils/tab.js';
import {
    initFilter,
    initCompetenciesFilter,
    initSelectAllCompetencies
} from './utils/filter.js';
import firstChartData from './utils/data/first-chart.js';
import secondChartData from './utils/data/second-chart.js';
import thirdChartData from './utils/data/third-chart.js';
import initSelect from './utils/select.js';
import initPopup from './utils/popup.js';
import initDimensionsTooltip from './utils/dimensions-tooltip.js';
import renderAllCategories from "./utils/bar-chart.js";
import filterDataFunc from "./utils/filter-func.js";
import initTopFiveCharts from './utils/model-top-tabs.js'

document.addEventListener("DOMContentLoaded", async () => {
    // initInlineHorizontal();
    initLineFade();

    initRadarChart('firstChart', firstChartData);
    initRadarChart('secondChart', secondChartData);
    initRadarChart('thirdChart', thirdChartData);

    await renderAllCategories('#charts-root');

    initCompetenciesFilter();

    initFilter({ renderOnInit: false });
    initSelectAllCompetencies();

    initPopup();

    initSelect();
    initTopFiveCharts();

    initTab();

    initDimensionsTooltip();
});
